import React from "react";
import NotFoundBlock from "../components/not-found-block/NotFoundBlock";

const NotFound: React.FC = () => {
  return <NotFoundBlock />;
};

export default NotFound;
